import React from 'react';
// @ts-ignore
import jsxToString from 'jsx-to-string';
import AuthorOfQuote from './post/author-of-quote';
import { PostAuthor } from './Types';
import { parse, format } from 'date-fns';
import styles from 'components/blog/post/post.module.css';

export function getDate(date: string) {
  const d = parse(date, 'yyyy-MM-dd', new Date());
  return format(d, 'MMMM dd, yyyy');
}

export const convertPostContent = (text: string, authors: PostAuthor[]) => {
  let convertedText = text;
  const authorTags = text.match(/<\*\*(\w+) (\w+)\*\*>/g);
  const italicTags = text.match(/<\*[^\*][\s\S]*?[^\*]\*>/g);

  authorTags?.forEach((item) => {
    const author = authors?.find((el) => el.name === item.match(/(\w+) (\w+)/g)?.toString());
    if (author) {
      const Person = AuthorOfQuote(author);
      convertedText = convertedText.replace(/<\*\*(\w+) (\w+)\*\*>/, jsxToString(Person));
    }
  });

  italicTags?.forEach((item) => {
    const textContent = item.replace(/^.{2}/, '').replace(/.{2}$/, '');
    convertedText = convertedText.replace(
      item,
      jsxToString(<span className={styles.italic}>{textContent}</span>)
    );
  });

  return convertedText;
};
